export default function classNames(...args) {
  return args
    .reduce((list, clss) => list.concat(clss).filter(Boolean), [])
    .join(' ')
    .trim()
    .replace(/\s{2,}/g, ' ');
}
